import FormAction from "./FormAction/FormAction";
import FormActionApi from "./FormActionApi/FormActionApi";
import FormActionCondition from "./FormActionCondition/FormActionCondition";
import FormActionExtract from "./FormActionExtract/FormActionExtract";
import FormActionRedirection from "./FormActionRedirection/FormActionRedirection";
import FormActionVariable from "./FormActionVariable/FormActionVariable";
import FormJump from "./FormJump/FormJump";
import FormScenario from "./FormScenario/FormScenario";
import FormStatement from "./FormStatement/FormStatement";
import FormAnnouncement from "./FormAnnouncement/FormAnnouncement";
import FormFunction from "./FormFunction/FormFunction";
import FormActionCategorization from "./FormActionCategorization/FormActionCategorization";

// FormList component to access more easialy to form component
export default {
    default : FormAction,
    api : FormActionApi,
    condition : FormActionCondition,
    extract_data : FormActionExtract,
    keyword_redirection : FormActionRedirection,
    set_var : FormActionVariable,
    set_function : FormFunction,
    function : FormFunction,
    magic : FormJump,
    scenario : FormScenario,
    propos : FormStatement,
    announcement : FormAnnouncement,
    categorization : FormActionCategorization,
}